import { toast } from 'sonner';
import { ContactsTable, DirectoryRefresh } from '@/components/ContactsTable';
import { PageIntro, count } from '@/workspace/ui';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Visitors — every tracked contact (the newest 10,000 the API returns), searchable, with paging and bulk delete.
// Embedded, it is the Visitors tab of the Customer journeys screen.
export default function VisitorsPage({ embedded = false, contacts, loading, initialLoad, contactsError, error: loadError, stats, onRefresh, onSelectContact, onDeleteContact, onBulkDelete }) {
  const error = contactsError || loadError;
  const handleCopyScript = () =>
    navigator.clipboard.writeText(`<script src="${BACKEND_URL}/api/page.js"></script>`)
      .then(() => toast.success('Script copied!'));
  const Wrap = embedded ? 'div' : 'section';
  return <>
    {!embedded && <PageIntro title="Visitors" />}
    <Wrap className={embedded ? undefined : 'panel'} aria-label="Visitors list">
      <div className="toolbar" style={{ padding: '14px 20px 0' }}>
        <div className="toolbar-side"><span className="badge">{error ? 'Profiles unavailable' : `${count(stats?.total_contacts ?? contacts.length)} tracked`}</span></div>
        <div className="toolbar-side"><DirectoryRefresh onRefresh={onRefresh} loading={loading} label="Refresh visitors" /></div>
      </div>
      <ContactsTable
        contacts={contacts}
        loading={loading}
        initialLoad={initialLoad}
        error={error}
        onRetry={onRefresh}
        onSelectContact={onSelectContact}
        onCopyScript={handleCopyScript}
        onBulkDelete={onBulkDelete}
      />
    </Wrap>
  </>;
}
